module.exports = __webpack_public_path__ + "assets/img/highestPriority.7c791ee7.svg";